import type { FC } from 'react';
import { Accordion } from '@presentation/components';
import * as Styled from './styled';
import type { FaqAccordionProps } from './types';

export * from './types';

export const FaqAccordion: FC<FaqAccordionProps> = (props) => {
  const { tabs } = props;

  return (
    <Styled.AccordionWrapper>
      <Accordion
        noScroll
        tabs={tabs.map((tab) => ({
          title: tab.title,
          content: <Styled.AccordionContent>{tab.content}</Styled.AccordionContent>,
        }))}
      />
    </Styled.AccordionWrapper>
  );
};
